import { Dispatch, Fragment, SetStateAction } from "react";
import styled from "styled-components/macro";
import { useFields } from "../../hooks/use-fields";
import { Box, BoxContent, BoxConnector } from "../Box";
import MessageTemplate from "./MessageTemplate";
import { IconButton } from "../Button";
import { Plus } from "../Icons";
import Tooltip from "../Tooltip";
import { newMessageTemplate } from "./factories";
import { fixPositions } from "./util";
import { CampaignType } from "./types";
import { EditableMessageTemplate } from ".";

type MessageTemplateProps = {
  value: EditableMessageTemplate[];
  onChange: Dispatch<SetStateAction<EditableMessageTemplate[]>>;
  campaignType: CampaignType;
};

function MessageTemplates({
  value,
  onChange,
  campaignType,
}: MessageTemplateProps) {
  const { field, value: messageTemplates } = useFields({ value, onChange });

  const insertTemplate = (atIndex: number) => {
    onChange((templates) => {
      const clone = templates.slice();
      clone.splice(atIndex, 0, newMessageTemplate(campaignType));
      return clone.map(fixPositions);
    });
  };

  const remove = (index: number) => () => {
    onChange((templates) =>
      templates
        .map((item, i) => (i !== index ? item : { ...item, _destroy: true }))
        .map(fixPositions)
    );
  };

  return (
    <>
      <BoxLabel>
        <BoxContent dark>Start of Campaign</BoxContent>
      </BoxLabel>
      <BoxConnector />
      <Tooltip label="Add Message">
        <IconButton onClick={() => insertTemplate(0)}>
          <Plus />
        </IconButton>
      </Tooltip>
      <BoxConnector />
      {messageTemplates.map((template, index) =>
        template._destroy ? null : (
          <Fragment key={template.tempId || template.id}>
            <MessageTemplate
              index={index}
              campaignType={campaignType}
              {...field(index)}
              onRemove={remove(index)}
            />
            <BoxConnector />
            <Tooltip label="Add Message">
              <IconButton onClick={() => insertTemplate(index + 1)}>
                <Plus />
              </IconButton>
            </Tooltip>
            <BoxConnector />
          </Fragment>
        )
      )}
      <BoxLabel>
        <BoxContent dark>End of Campaign</BoxContent>
      </BoxLabel>
    </>
  );
}

export default MessageTemplates;

const BoxLabel = styled(Box)`
  max-width: 200px;
  margin: auto;
  border-style: dashed;
  ${BoxContent} {
    text-align: center;
    padding: 15px 20px;
    font-weight: 500;
    color: #707070;
  }
`;
